function MinWingWidth({ dataset, corners = 0, hasCore = false }) {
  const smallestAboveEntrance = Math.min(...dataset.apartments.aboveEntrance.map((a) => a.size[0]));
  let minWidth = smallestAboveEntrance;
  minWidth += (WingDepth(dataset, false) + dataset.aggConfig.gap) * corners;
  if (hasCore) {
    minWidth += dataset.aggConfig.coreWithFfLifts.size[0];
    minWidth += dataset.aggConfig.gap;
  }
  return minWidth;
}
function WingDepth(dataset, includesBalcony) {
  if (includesBalcony)
    return dataset.aggConfig.maxApartmentDepth * 2 + dataset.aggConfig.corridorWidth;
  else
    return dataset.aggConfig.moduleDepth * 2 + dataset.aggConfig.corridorWidth;
}
const WingUtils = { MinWingWidth, WingDepth };
export {
  WingUtils
};
//# sourceMappingURL=index178.js.map
